import React from "react";
import { searchConfig } from "./config";
import LookupDisplay from "./LookupDisplay";
import { SearchManager } from "./SearchManager";

export default function SplitTaxViewer() {
    return (
        <LookupDisplay searchManager={new SearchManager(searchConfig)}/>
    )
}